/**
 * @desc 校验交货单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<string>;
export function request(dono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierDeliveryOrder/checkDono/${dono}`, {
      method: "POST",

      ...options,
    }),
  );
}
